module.exports = __webpack_public_path__ + "static/media/avatar.6112c4bc.svg";